import React, { useState } from "react";
import {
	Flex,
	Box,
	Heading,
	Text,
	Button,
	Image,
	useColorMode,
} from "@chakra-ui/core";
import { userAtom } from "../global/gloablState";
import { useRecoilValue } from "recoil";

const Home = ({ history }) => {
	const user = useRecoilValue(userAtom);
	const { colorMode } = useColorMode();

	const featuresForUser = [
		{
			title: "Easy access with QR code",
			image: require("../assets/images/qr.png"),
			imageAlt: "Easy access with QR code",
			desc:
				"Customers can scan the QR code placed on their respective table. They can join particular room as guest users by entering the unique Room Id.",
		},
		{
			title: "Everything at a click",
			image: require("../assets/images/tap.png"),
			imageAlt: "Everything at a click",
			desc:
				"Admin of the table can grant members of the table different permissions like view only and edit. Customers can place and pay order in just few clicks.",
		},
		{
			title: "Track Order History",
			image: require("../assets/images/history.png"),
			imageAlt: "Track Order History",
			desc:
				"They can view recent orders history with the proper bill of the orders.",
		},
	];

	const featuresForRestro = [
		{
			title: "Menu Management",
			image: require("../assets/images/menu.png"),
			imageAlt: "Menu Management",
			desc:
				"A Web portal for menu management to add/edit items according to the need from any platform.",
		},
		{
			title: "Track Orders",
			image: require("../assets/images/history.png"),
			imageAlt: "Track Orders",
			desc:
				"It also provides with the live order and payment status of respective table.",
		},
		{
			title: "Live Updates",
			image: require("../assets/images/notify.png"),
			imageAlt: "Live Updates",
			desc:
				"Push notification on successful placement of order and payment of the order.",
		},
	];

	const steps = [
		{
			id: 0,
			image: require("../assets/mocks/2.png"),
			desc:
				"Firstly, you will get option to either signup or login in the app.",
		},
		{
			id: 1,
			image: require("../assets/mocks/3.png"),
			desc:
				"Signup in the app if you are not logged in. You can also signup using Google Oauth.",
		},
		{
			id: 2,
			image: require("../assets/mocks/4.png"),
			desc:
				"After that, you can scan the qr code or enter the tableId to join a particular table as an admin.",
		},
		{
			id: 3,
			image: require("../assets/mocks/5.png"),
			desc:
				"On successful joinning of table, you will get a unique Room Id which can be shared with the other table members to let them join that particular table as guest. Admin can also set permission for other table members to either only view the menu or edit it.",
		},
		{
			id: 4,
			image: require("../assets/mocks/6.png"),
			desc:
				"The other table members can join the table with that unique Room Id either by loginning in or as guest users.",
		},
		{
			id: 5,
			image: require("../assets/mocks/7.png"),
			desc:
				"Logged in users can also view and edit profile.They can also view recent orders if any.",
		},
		{
			id: 6,
			image: require("../assets/mocks/8.png"),
			desc:
				"Admin after successfully setting permission will be taken to menu screen where admin and all the table members can select menu items(depending upon permission) and proceed for placing the order.",
		},
		{
			id: 7,
			image: require("../assets/mocks/9.png"),
			desc:
				"Here admin will get the description and price of the menu items. And then can proceed for payment by choosing either of the payment options mentioned.As soon as the payment is confirmed from restauarant side, order will be confirmed.",
		},
	];

	const [currentStep, setCurrentStep] = useState(0);

	return (
		<Box px={["5%", "10%"]} py="5">
			<Flex direction={["column", "row"]}>
				<Flex
					flex={1}
					align="flex-start"
					direction="column"
					justify="space-evenly"
					m={80}>
					<Text fontSize="xl" fontWeight="bold">
						Welcome to Salyd
					</Text>
					<Text fontSize="m">
						This project aims to bring a flawless contactless
						dinning experience, where the customers coming to the
						restaurant can scan the qr code and get the menu on
						their respective screens.
					</Text>
					<Button
						variantColor="green"
						onClick={() => {
							if (user) {
								history.push("/dashboard");
							} else {
								history.push("/signup");
							}
						}}>
						Get Started
					</Button>
				</Flex>
				<Flex flex={1} justify="center" align="center">
					<Image
						src={require("../assets/images/mobile.svg")}
						m={30}
						size={300}
					/>
				</Flex>
			</Flex>
			<Flex align="center" direction="column">
				<Heading textAlign="center" size="lg" mb={10}>
					Features for Users
				</Heading>
				<Flex
					width="100%"
					justify="space-around"
					direction={["column", "row"]}
					align="center">
					{featuresForUser.map(({ title, image, imageAlt, desc }) => (
						<Box
							key={title}
							textAlign="center"
							maxW="300px"
							borderWidth="1px"
							mb={10}
							rounded="lg"
							overflow="hidden">
							<Image
								src={image}
								ml={50}
								mt={30}
								alt={imageAlt}
								size={200}
							/>
							<Text fontWeight="bold" mt={3}>
								{title}
							</Text>
							<Text color="gray.500" m={5} mt={3}>
								{desc}
							</Text>
						</Box>
					))}
				</Flex>
			</Flex>
			<Flex align="center" direction="column">
				<Heading textAlign="center" size="lg" mb={10}>
					Features for Restraunts
				</Heading>
				<Flex
					width="100%"
					justify="space-around"
					direction={["column", "row"]}
					align="center">
					{featuresForRestro.map(
						({ title, image, imageAlt, desc }) => (
							<Box
								key={title}
								textAlign="center"
								maxW="300px"
								borderWidth="1px"
								mb={10}
								rounded="lg"
								overflow="hidden">
								<Image
									src={image}
									ml={50}
									mt={30}
									alt={imageAlt}
									size={200}
								/>
								<Text fontWeight="bold" mt={3}>
									{title}
								</Text>
								<Text color="gray.500" m={5} mt={3}>
									{desc}
								</Text>
							</Box>
						)
					)}
				</Flex>
			</Flex>
			<Flex align="center" direction="column">
				<Heading textAlign="center" size="lg" mb={10}>
					How to use?
				</Heading>
				<Flex
					width="100%"
					justify="space-around"
					direction={["column", "row"]}
					align="center">
					<Flex direction="column">
						{steps.map(({ id, image, desc }) => (
							<Box
								key={id}
								bg={currentStep === id && "green.100"}
								p={5}
								shadow="md"
								borderWidth="1px"
								onClick={() => setCurrentStep(id)}
								mb={5}>
								<Heading
									color={
										colorMode === "dark" &&
										currentStep === id &&
										"black"
									}
									fontSize="xl">
									Step {id + 1}
								</Heading>
								<Text
									color={
										colorMode === "dark" &&
										currentStep === id &&
										"black"
									}
									mt={4}>
									{desc}
								</Text>
							</Box>
						))}
					</Flex>
					<Image
						src={steps[currentStep].image}
						ml={50}
						mt={30}
						alt="None"
						height={600}
					/>
				</Flex>
			</Flex>
		</Box>
	);
};

export default Home;
